import { AnalyticsBrowser } from '@segment/analytics-next'
import type { AnalyticsProperties, CandidateCardAnalyticsProperties } from '../types'

export const analytics = AnalyticsBrowser.load({
  writeKey: import.meta.env.VITE_SEGMENT_KEY
})

export const analyticsTrack = (eventName : string, properties : AnalyticsProperties | CandidateCardAnalyticsProperties) => {
  analytics.track(eventName, {
    category: properties.category,
    action: properties.action,
    label: properties.label,
    source_detail: properties.source_detail,
    source: properties.source,
    ...properties
  })
}

export const analyticsIdentify = (userId: string) => {
  analytics.identify(userId)
}
